"use client";
import { useTranslations } from "next-intl";
import React from "react";
import { Link } from "@/i18n/navigation";

function BreadcrumbItem({
  url,
  name,
  index,
  isLast,
}: {
  url: string;
  name: string;
  index: number;
  isLast: boolean;
}) {
  const t = useTranslations("footer");
  return (
    <React.Fragment>
      <li
        itemProp="itemListElement"
        itemScope
        itemType="https://schema.org/ListItem"
        key={index}
        className="flex items-center"
      >
        <Link
          itemProp="item"
          href={url}
          className="text-white hover:text-gray-100 transition-colors duration-200 text-sm font-medium"
        >
          <span itemProp="name" className="capitalize">
            {name}
          </span>
        </Link>
        <meta itemProp="position" content={index.toString()} />
      </li>

      {!isLast && <span className="text-gray-100 mx-2 text-sm">&gt;</span>}
    </React.Fragment>
  );
}

export default BreadcrumbItem;
